// A pulsing placeholder block for first-load states — better than a bare spinner for lists
// (honours the "never a blank screen" rule while hinting at the shape of what's coming). Use it
// only for the true first load (isLoading, no data yet); the global FetchingBar covers background
// refetches where stale data is already on screen. Reach for Spinner where a spinner still fits
// (buttons, the video player).
interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = 'h-4 w-full' }: SkeletonProps) {
  return <div className={'animate-pulse rounded bg-surface-2 ' + className} aria-hidden="true" />;
}

// First-load placeholder for the admin table lists (federations, invites, sports, …): a bordered
// card with a handful of pulsing rows, matching the real list's frame so the swap-in doesn't shift
// layout. `rows` tunes the height to the list's typical size.
interface ListSkeletonProps {
  rows?: number;
}

export function ListSkeleton({ rows = 5 }: ListSkeletonProps) {
  return (
    <div className="rounded border border-line bg-surface p-3" aria-hidden="true">
      <div className="space-y-2.5">
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-9 w-full" />
        ))}
      </div>
    </div>
  );
}
